<template>
<v-container
    fluid
    class="pa-0"
    :class="[$vuetify.breakpoint.xlOnly ? 'carrier-container-xl' : 'carrier-container-lg-down']"
    >
      <v-row no-gutters
        justify="center"
      >
        <v-col v-if="shipment.__typename === 'Shipment1PL' || shipment.__typename === 'Shipment2PL'">
          <span class="text-no-wrap d-block wrld_black--text">{{shipment.departureUTC | timeToReadableSchedule}} - {{shipment.arrivalUTC | timeToReadableSchedule}}</span>
          <span class="text-no-wrap d-block wrld_black--text">{{shipment.schedule.metrics.totalDuration | durationToHoursMinutes}}</span>
        </v-col>
        <v-col v-else-if="shipment.__typename === 'Shipment1PL' || shipment.__typename === 'Shipment2PL' || shipment.vehicle === null">
          <span class="text-no-wrap d-block mt-3 wrld_black--text">{{$t('shipments.missing_vehicle')}}</span>
        </v-col>
        <v-col v-else-if="shipment.__typename === 'ShipmentLTL' || shipment.__typename === 'ShipmentExpress'">
          <span v-if="shipment.departure !== null" class="text-no-wrap d-block wrld_black--text">{{shipment.departure | timeToReadableTz}}</span>
          <span v-if="shipment.carrier !== null" class="text-no-wrap d-block text-truncate wrld_black--text">{{shipment.carrier}}</span>
        </v-col>
        <v-col v-else-if="shipment.__typename === 'ShipmentCustom'">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <span v-on="on" v-if="shipment.providerName != null" class="text-no-wrap d-block text-truncate wrld_black--text">{{shipment.providerName}}</span>
            </template>
            <span v-if="shipment.providerName != null" class="text-no-wrap d-block text-truncate wrld_primary_text--text">{{shipment.providerName}}</span>
          </v-tooltip>
        </v-col>
        <v-col v-else-if="shipment.__typename === 'ShipmentLTL' || shipment.__typename === 'ShipmentExpress' || shipment.carrier === null">
          <span class="text-no-wrap d-block wrld_black--text">{{$t('shipments.missing_carrier')}}</span>
        </v-col>
        <v-col v-else-if="shipment.__typename === 'Shipment3PL'">
          <span
            v-if="shipment.quoting.selectedQuote.organization.name != null"
            class="text-no-wrap d-block wrld_black--text"
          >
          {{
            shipment.quoting.selectedQuote.organization.name
            }}
          </span>
          <span v-else class="text-no-wrap d-block mt-3 wrld_black--text">{{$t('shipments.missing_carrier')}}</span>
        </v-col>
        <v-col v-else-if="shipment.__typename === 'NotTypedShipment'"
        >
          <span class="text-no-wrap d-block wrld_black--text">
            {{ $t('shipments.missing_carrier')}}
          </span>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'CarrierGroupByDay',
   components: {},
  props: {
    shipment: Object
  },
  data () {
    return {}
  },
  created () {},
  mounted () {},
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.carrier-container-xl {
  margin-left: -39px;
}
.carrier-container-lg-down {
  margin-left: -37px;
}
</style>
